import { useWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';
import { Navigate } from 'react-router-dom';
import { generatePath } from '@/services/router/generate-path';

export default function Tasks() {
  const workspaceId = useWorkspaceIdFromCurrentUrl();
  // Keep this route, but we redirect to the health page now
  return (
    <Navigate
      to={generatePath(
        '/workspaces/:workspaceId/health',
        { workspaceId: workspaceId ?? 0 },
        { tab: 'data', scrollTo: 'tasks' },
      )}
      replace={true}
    />
  );
}
